<h2 mat-dialog-title>Edit Fee Snapshot: {{ data.runLabel }}</h2>

<mat-dialog-content>
  <p class="hint">Recomputes payable amount from coins transferred using the corrected rate. Blocked once the run is paid.</p>
  <form [formGroup]="form" class="fee-form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Fee Snapshot</mat-label>
      <input matInput type="number" formControlName="fee_snapshot" placeholder="0">
      <mat-error>{{ getErrorMessage() }}</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">
    Save
  </button>
</mat-dialog-actions>
